import { render, staticRenderFns } from "./sideLayout.vue?vue&type=template&id=60e82ca5&scoped=true&"
import script from "./sideLayout.vue?vue&type=script&lang=js&"
export * from "./sideLayout.vue?vue&type=script&lang=js&"
import style0 from "./sideLayout.vue?vue&type=style&index=0&id=60e82ca5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e82ca5",
  null
  
)

export default component.exports